module.exports = __webpack_public_path__ + "img/doorLogo16.4e49588c.png";